export const API_ENDPOINTS = {
  refreshToken: "/user/refreshToken",
  login: "/auth/userLogin",
  loginWithToken: "/auth/loginWithToken",
  ssoLoginApi: "/user/redirectToBack",
  changestatus: "/user/update",
  unMuteUser: "/user/unmute-user",
  // muteUser: "/user/mute-user",
  markAsUnread: "/messages/message-unread",
  addFavApi: "/favouriteLists/add",
  closeConversationApi: "/chatList/close-conversation",
  addAdmin: '/superAdmin/addAdmin',
  getAdminList: '/superAdmin/getAdminList',
  getAdminList: '/superAdmin/getAdminList',
  deleteAdmin: '/superAdmin/deleteAdmin',

  editAdminList: '/superAdmin/editAdmin',
  getCompanyList: '/CompanyManage/getCompanyList',
  addCompany: '/CompanyManage/addCompany',
  editCompany: '/CompanyManage/editCompany', // We'll append the ID in the component
  deleteCompany: '/CompanyManage/deleteCompany',
  getCompanyDetailsBySlug: '/CompanyManage/get-company-details-by-slug',

  getUsersList: '/adminManage/getUsersList',
  addUser: '/adminManage/addUser',
  editUser: '/adminManage/editUser',
  deleteUser: '/adminManage/deleteUser',

  importUsers: "/adminManage/admin/users/upload-csv",

  searchUserChannel: '/search/searchUserChannel',//search user in DM

  //get user by id
  getUserDetails: "user/getUserDetails",

  //channel
  channelManage: '/channelManage/addChannel', //create channel
  getChannel: "/channelManage/getChannel",//get channl,
  browseChannel: '/channelManage/searchUserChannel',//searchUserChannel
  leaveChannel: "/channelManage/leaveChannel", // leave channel
  editChannel: "/channelManage/editChannel",
  addFavoriteChannel: "/favorite/addFavoriteChannel",
  getFavoriteChatList: "/favorite/getFavoriteChatList",
  removeFavoriteChannel: "/favorite/removeFavoriteChannel",
  getChannelById: "/channelManage/getChannelById",
  getChannelMembers: "/channelManage/getChannelMembers",
  sendChannelMessage: "/channelMessage/sendMessage",
  getChannelMessage: "/channelMessage/getMessages",
  searchUsersInChannel: "/search/searchUserChannel",
  getPinnedMessageChannel: "/channelMessage/getPinnedMessages",
  changeMemberRole: "/channelManage/toggleAdmin",

  removeMemberFromChannel: "/channelManage/removeMember",

  muteManage: "/muteManage/muteChannel",//mute channel
  unmuteChannel: "/muteManage/unmuteChannel",//unmute channel  
  getMessageById: "/chatMessage/getMessageById",
  addMemberChannel: "/channelManage/addMember", //add member to channel
  getFileListingChannel: "/channelMessage/getFileList",
  getFilesListing: "/chatMessage/getFileList",


  //chatList
  getChatList: "/chatList/getChatList",
  addUserInChatList: "/chatList/addInChatList",
  closeConversation: "/chatList/closeConversation",
  //  removeFavoriteChannel:"/favorite/removeFavoriteChannel",
  //  addFavoriteChannel:"/favorite/addFavoriteChannel",




  //replies
  getReplies: "/reply/getReplies",



  //chatMessage
  getMessages: "/chatMessage/getMessages",
  sendMessage: "/chatMessage/sendMessage",
  addFavoriteChat: "/favorite/addFavoriteChat",
  removeFavoriteChat: "/favorite/removeFavoriteChat",
  muteUser: "/muteManage/muteUser",//mute channel
  unmuteUser: "/muteManage/unmuteUser",//unmute channel  

  //chatMessageAction
  deleteMessage: '/chatMessageAction/deleteMessage',
  pinMessage: '/chatMessageAction/pinMessage',
  reactionMessage: "chatMessageAction/reactionMessage",
  removeMessageReaction: "chatMessageAction/removeMessageReaction",


  updateUserDetails: "user/updateUserDetails",
  getUserSuggestions: "user/getUserSuggestions",


  //search message
  searchMessage: "/searchMessage/search",
  jumpToMessage: "/chatMessage/getMessageJump",


  //seen channel message
  messageSeenChannel: "/channelMessage/seenMessage",
  unreadmessageSeenChannel: '/channelManage/unreadMessage',
  fileUpload: "/upload/uploadFile",
  //seen message

  messageSeenChat: '/chatMessageAction/seenMessage',
  unreadMessage: '/chatMessageAction/unreadMessage',


  replymessageSeen: "/reply/seenMessage",


  getUnreadThread: 'unreadThread/getUnreadThread',
  unreadThreadsCount: 'unreadThread/getUnreadThreadCount',


  // company registration

  registerCompany: "CompanyReg/registerAdminAndCompany",

  forgetPassword: "/auth/forgotPassword",
  resetPassword: "/auth/resetPassword",


  smtpConfig: 'smtpConfig/verifyAndSaveSMTP',
  smtpGetConfig: 'smtpConfig/getSmtpConfig',

  //file size limit
  fileSizeUpload: "/CompanyManage/file-upload-size",



  // Dashboard API

  getDashboardData: "superAdmin/getDashboardData",

  compyRgetVerfy: '/CompanyReg/verify-registration',

  // Connected products launcher (proxies WeekMate Registration)
  linkedProducts: "/linked-products",
};
